import api from './api';

export const deputyService = {
  // Get all deputy
  getAll: async (type = null, includeInactive = false) => {
    const params = {};
    if (type) params.type = type;
    if (includeInactive) params.includeInactive = includeInactive;
    
    const response = await api.get('/deputy', { params });
    return response.data;
  },

  // Get recent deputy
  getRecent: async (limit = 5) => {
    const response = await api.get('/deputy/recent', {
      params: { limit },
    });
    return response.data;
  },

  // Get pinned deputy
  getPinned: async () => {
    const response = await api.get('/deputy/pinned');
    return response.data;
  },

  // Search deputy
  search: async (query) => {
    const response = await api.get('/deputy/search', {
      params: { q: query },
    });
    return response.data;
  },

  // Get deputy by ID
  getById: async (id) => {
    const response = await api.get(`/deputy/${id}`);
    return response.data;
  },

  // Get deputy by slug
  getBySlug: async (slug) => {
    const response = await api.get(`/deputy/slug/${slug}`);
    return response.data;
  },

  // Create deputy (admin)
  create: async (data) => {
    const response = await api.post('/deputy', data);
    return response.data;
  },

  // Update deputy (admin)
  update: async (id, data) => {
    const response = await api.put(`/deputy/${id}`, data);
    return response.data;
  },

  // Delete deputy (admin)
  delete: async (id) => {
    const response = await api.delete(`/deputy/${id}`);
    return response.data;
  },
};

export default deputyService;
